import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import { immerable, produce } from 'immer';
import { Map } from 'immutable';

import { ProfileItemEntity } from './profile-item.entity';

export interface IProfileListExtra
	extends IListColumnConfig<ProfileItemEntity> {
	isFixed?: boolean;
	isSelectable?: boolean;
	isSearchable?: boolean;
	isInGroup?: boolean;
	isVisible?: boolean;
	canBeHidden?: boolean;
	canBeReordered?: boolean;
	canBeChosen?: boolean;
	format?: string;
}

interface IProfileListEntity extends IListAttrs<ProfileItemEntity> {
	availableColumns: Map<string, IProfileListExtra>;
}

const entityDefaults: IProfileListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class ProfileListEntity
	implements
		IProfileListEntity,
		IListOperations<ProfileListEntity, ProfileItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(
		availableCols: Array<IProfileListExtra>
	): ProfileListEntity {
		const inst = new ProfileListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, IProfileListExtra]>());
		inst.availableColumns = Map(cols);
		return inst;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<ProfileItemEntity>
	> {
		return this.availableColumns;
	}

	public setElements(elems: Map<string, ProfileItemEntity>): ProfileListEntity {
		return produce(this, (draft: ProfileListEntity) => {
			draft.elements = elems;
		});
	}
}
